import React, { useEffect, useState, useRef } from "react";

function RecentBack() {
    const [back, setBack] = useState({});
    const [showMedias, setShowMedias] = useState(false);
    const backRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/media/list-recents');
                const data = await response.json();

                // Shuffle the data randomly immediately
                const shuffledBack = data.sort(() => Math.random() - 0.5);

                // Pick a random index
                const randomIndex = Math.floor(Math.random() * shuffledBack.length);

                // Use the ref to store the mutable object
                backRef.current = shuffledBack[randomIndex];

                // Add a delay of 5,000ms (5 seconds) before setting the state with shuffled data
                setTimeout(() => {
                    setBack(backRef.current);
                    // Set showMedias to true after 2 seconds
                    setTimeout(() => {
                        setShowMedias(true);
                    }, 1000);
                }, 800);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className={`film-back ${showMedias ? "show" : ""}`}>
            <video muted autoPlay loop id="vid">
                {back.nom ? (
                    <>
                        <source src={back.bd} type="video/mp4" />
                        <source src={back.bd} type="video/ogg" />
                    </>
                ) : (
                    <p>Your browser does not support the video tag.</p>
                )}
            </video>

            <div className="desc" style={{ opacity: showMedias ? 1 : 0, transition: showMedias ? 'opacity 2s ease-in' : 'none' }}>
                <h2 className="titre">{back.nom}</h2>
                <p>{back.duree}</p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem, ad recusandae. Facere quos maxime quo, labore illum odit autem minus magni, corrupti deserunt cupiditate numquam voluptates! Quidem cum nemo iusto!</p>
                <div className="lecture">
                    <a href={`/video/${back._id}`} className="btn-lecture">Lecture</a>
                    <a href="" className="btn-infos">Plus d'infos</a>
                </div>
            </div>
        </div>
    );
}

export default RecentBack;
